var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20,16h2v5l-1,1H3l-1-1V3l1-1h5v2h-4v16h16v-4ZM14,2v2h4.59l-7.29,7.29,1.41,1.41,7.29-7.29v4.59h2V2h-8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModal);
export default __webpack_public_path__ + "static/1765983986/media/icon-modal.dde82fde5aaee8ed94d137e0e11c4b23.svg";
export { ForwardRef as ReactComponent };